module.exports = __webpack_public_path__ + "img/logo.bed3d016.png";